import { createApp } from 'vue';

import StickyPanels from './StickyPanels.vue';

function mountStatCardsContainerBlocks() {
	const blocks = document.querySelectorAll('[data-feature="sticky-panels"]');

	blocks.forEach((block) => {
		const app = createApp({
			name: 'StickyPanelsApp',
		});

		app.component('sticky-panels', StickyPanels);
		app.mount(block);
	})
}

mountStatCardsContainerBlocks();